/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgClass } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { NumberOnlyDirective } from '@shared/directives/only-number.directive';
import { MSISDN } from '@utils/constants';
import { ErrorMessagePipe } from './error-message.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'input-msisdn',
  standalone: true,
  imports: [NgClass, NumberOnlyDirective, ReactiveFormsModule, ErrorMessagePipe, TranslatePipe],
  templateUrl: './input-msisdn.component.html',
  styleUrl: './input-msisdn.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputMsisdnComponent,
      multi: true
    }
  ]
})
export class InputMsisdnComponent implements ControlValueAccessor {
  isShowResetInput = input<boolean>(false);
  resetEvent = output<void>();
  validEvent = output<boolean>();

  value = signal<string>('');
  isDisabled = signal<boolean>(false);

  private readonly msisdnPattern: string = '^08(1[123]|2[123]|5[123])[0-9]{5,10}$';
  control: FormControl = new FormControl('',
    [
      Validators.minLength(MSISDN.MIN_LENGTH),
      Validators.pattern(this.msisdnPattern)
    ]
  );

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  get isValid() {
    const IS_VALID = !this.control.hasError('pattern') && !this.control.hasError('minlength');
    this.validEvent.emit(IS_VALID);

    return IS_VALID;
  }

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) this.control.disable();
 }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.onChange(input.value);
  }

  onClickResetInput() {
    this.control.reset();
    this.resetEvent.emit();
  }

}
